import React from 'react';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Row } from 'shared/components/birch/row';
import CandidateChips, {
  hasNonTagChips,
} from 'talent_matching/components/shared/candidate_chips';
import { RejectModalProvider } from 'application_review/components/reject_modal_context';
import SocialLinks from 'talent_matching/components/shared/social_links';
import { Person } from 'talent_matching/types';
import { Body, TertiaryBody } from '@grnhse/seedling/lib/birch/typography';
import noop from 'lodash/noop';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.rediscovery_candidate_cell'
);

type Props = {
  applicationId: number;
};

const RediscoveryCandidateCell = ({ applicationId }: Props) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  const appCountsKey =
    application.activeAppsCount > 0 && application.pastAppsCount > 0
      ? 'active_and_past'
      : application.activeAppsCount > 0
      ? 'active_only'
      : 'past_only';
  const appCountsText = t(`application_counts.${appCountsKey}`, {
    active_count: application.activeAppsCount,
    past_count: application.pastAppsCount,
    count:
      appCountsKey === 'past_only'
        ? application.pastAppsCount
        : application.activeAppsCount,
  });

  return (
    <Stack
      spacing={1}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <Row spacing={0.5}>
        <Body medium className="candidate-full-name pii-blur">
          {application.fullName}
        </Body>
      </Row>

      {hasNonTagChips(application as unknown as Person) && (
        <CandidateChips application={application as unknown as Person} />
      )}

      <TertiaryBody>{appCountsText}</TertiaryBody>

      <RejectModalProvider>
        <SocialLinks
          application={application as unknown as Person}
          onRejectSuccess={noop}
        />
      </RejectModalProvider>
    </Stack>
  );
};

export default RediscoveryCandidateCell;
